export var Unit;
(function (Unit) {
    let type;
    (function (type) {
        type["UNIT"] = "Unit";
    })(type = Unit.type || (Unit.type = {}));
})(Unit || (Unit = {}));
